import { BaSeMessage, BaSeOptionPicker } from '@base/react';
import * as React from 'react';
import {
  categoryComboDataToValues,
  CategoryComboModel,
} from '../models/category-model';
import { useCategoryService } from '../services/category-combo-service';

interface CategoryComboContainerProps {
  occupationalScopeId?: number;
  ufId?: number;
  onChange(selectedId: number): void;
  initialSelectedId?: number;
  isOccupationalScopeIdRequired?: boolean;
  hasLabel?: boolean;
  label?: string;
}
const CategoryComboContainer: React.FC<CategoryComboContainerProps> = ({
  occupationalScopeId,
  onChange,
  ufId,
  initialSelectedId,
  isOccupationalScopeIdRequired = true,
  hasLabel = true,
  label = 'Agora selecione a categoria da História',
}) => {
  const {
    fetchCategoryComboLoading: loading,
    fetchCategoryComboError: error,
    fetchCategoryCombo,
  } = useCategoryService();

  const [data, setData] = React.useState<CategoryComboModel[]>();
  const [selected, setSelected] = React.useState<number | undefined>(
    initialSelectedId,
  );

  React.useEffect(() => {
    if (initialSelectedId) setSelected(initialSelectedId);
  }, [initialSelectedId]);

  const fetchData = React.useCallback(() => {
    if (occupationalScopeId || !isOccupationalScopeIdRequired) {
      fetchCategoryCombo({ occupationalScopeId }).then(setData);
    }
  }, [occupationalScopeId, isOccupationalScopeIdRequired, fetchCategoryCombo]);

  React.useEffect(() => fetchData(), [fetchData]);

  React.useEffect(() => {
    if (!initialSelectedId) {
      setSelected(undefined);
    }
  }, [occupationalScopeId, ufId, initialSelectedId]);

  if (error) {
    return (
      <BaSeMessage
        color="destructive"
        title="Ops! Não foi possível carregar as opções de Categoria"
        message={error.message}
        action="Tentar novamente"
        onAction={() => fetchData()}
      />
    );
  }

  return !isOccupationalScopeIdRequired || (ufId && occupationalScopeId) ? (
    <BaSeOptionPicker
      label={hasLabel ? label : ''}
      emptyValueLabel="Selecione"
      isLoading={loading}
      values={categoryComboDataToValues(data)}
      initialSelectedValuesId={selected ? [selected] : []}
      maxOptionsSelected={1}
      onChange={(selectedValue) => {
        const selectedId = selectedValue?.[0]?.id;
        if (selectedId) {
          setSelected(selectedId);
          onChange(selectedId);
        }
      }}
    />
  ) : (
    <React.Fragment />
  );
};

export { CategoryComboContainer };
